import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

// This function is a wrapper around clsx that also merges the classes with TailwindCSS
export function cn(...inputs) {
  return twMerge(clsx(inputs));
}
